import { PromotoresPlataformaService } from "../../../shared/generated/grpc/plataforma_terceros_promotores_pb";
import { PromotorResponse } from "../../../shared/response/terceros/PromotorResponse";
import { PromotorPayload } from "../../../shared/services/api/payload/terceros/PromotorPayload";
import { ServiceSaveBase } from "../../../shared/services/base/ServiceSaveBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";
import { PromotorService, toPromotorResponse } from "./PromotorService";

/** Alta y edición de promotor; el resultado reemplaza la fila del listado (`upsert` de la base). */
export class PromotorSaveService extends ServiceSaveBase<PromotorResponse, PromotorPayload> {
  protected readonly cache = PromotorService.instance;

  /**
   * gRPC-Web (`GuardarPromotor`): sin `id` crea el promotor y su usuario de Plataforma (el servidor manda el
   * correo de bienvenida); con `id` edita. En Nitrofert, si ya hay un usuario con ese correo, la ficha se enlaza a él
   * y le da el rol comercial (`enlazadoAUsuarioExistente`), y editar la ficha no toca al usuario.
   */
  protected async sendSave(payload: PromotorPayload): Promise<PromotorResponse> {
    const p = await grpcCall(() => grpcClient(PromotoresPlataformaService).guardarPromotor({
      id: payload.id ?? undefined,
      nombre: payload.nombre,
      email: payload.email,
      telefono: payload.telefono,
      tipo: payload.tipo ?? undefined,
      isActivo: payload.isActivo,
    }));
    return toPromotorResponse(p);
  }
}
